@if (!(isLoading$ | async)) {
  <app-dashboard-assessment-hierarchy-group
    [programHierarchy]="programHierarchy$ | async"
    [hierarchyLevel]="0"
  ></app-dashboard-assessment-hierarchy-group>
} @else {
  <ion-card-content class="card-content custom-skeleton">
    <ion-list class="list">
      @for (item of [0, 1, 2]; track item) {
        <ion-item class="list-item" lines="full">
          <ion-label>
            <h3 class="list-item__title list-item__title--ellipsis">
              <ion-skeleton-text animated style="width: 80%;"></ion-skeleton-text>
            </h3>
          </ion-label>
        </ion-item>
      }
    </ion-list>
  </ion-card-content>
}

